import React from 'react';

import {
  FormControl,
  FormControlLabel,
  Box,
  FormHelperText,
  Switch,
} from '@mui/material';

export default function PublicField({ value, setValue, setChanged }) {
  return (
    <Box>
      <FormControl fullWidth>
        <FormControlLabel
          control={
            <Switch
              checked={value}
              onChange={() => {
                setChanged();
                setValue(!value);
              }}
            />
          }
          label='Allow Public Jobs'
        />
        <FormHelperText id='public-helper-text'>
          Earn credits by allowing other proxiML users to run jobs on your spare
          capacity
        </FormHelperText>
      </FormControl>
    </Box>
  );
}
